import React from "react";

const SvgTick = props => <svg viewBox="0 0 20 20" {...props}><g fill="none" fillRule="evenodd"><path fill="#9AA7B1" d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8" /><path fill="#603276" d="M12.293 7.293L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a.996.996 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414" /></g></svg>;

export default SvgTick;